<template>
  <layout-default>
    <layout-introduction
      title="SKILLS"
      subtitle="スキル"
      :fullscreen="false"
    />

    <div class="box--wrapper">
      <div class="pager--inner">

        <div class="category-row row" v-for="(item, index) in skills" :key="index">
          <div class="col-12">
            <div class="skill--category_title">
              <h3>{{ item.category }}</h3>
            </div>
            <div class="col-12" v-if="item.skills">
              <div class="box-skill" :key="`${index}-${index2}`" v-for="(skill, index2) in item.skills">
                <div class="skill-logo"><img :src="`/static/img/skills/${skill}`"></div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </layout-default>
</template>

<style lang="scss" scoped>
  ul {
    margin: 12px 0 12px 32px;
  }
  .text--about {
    margin-top: -100px;
    padding: 0 70px;
  }
</style>

<script>
import LayoutDefault from '@/components/layouts/default/Layout';
import LayoutIntroduction from '@/components/layouts/common/Introduction';
import CommonAbout from '../common/About';

export default {
  metaInfo: {
    title: 'Skills - Jerome Dupuis Portfolio'
  },
  components: {
    LayoutDefault,
    LayoutIntroduction,
    CommonAbout
  },
  data() {
    return {
      skills: [
        {
          category: "BASICS",
          skills: ["html5.png", "css.png", "js.png"]
        },
        {
          category: "FRONT END",
          skills: ["jquery.png", "vuejs.png", "nuxt.png", "react.png", "redux.png", "createjs.png", "gulp.png", "sass.png"]
        },
        {
          category: "BACK END",
          skills: ["php.png", "cakephp.png", "laravel.png", "wordpress.png", "graphql.png"]
        },
        {
          category: "DATABASE",
          skills: ["mysql.png", "mongodb.png", "firestore.svg"]
        },
        {
          category: "INFRA",
          skills: ["gcp.png", "firebase.jpg", "googlestorage.png", "s3.png", "cloudflare.png"]
        },
        {
          category: "DESIGN",
          skills: ["photoshop.png"]
        },
        {
          category: "TOOLS",
          skills: ["git.png", "github.png", "gitlab.png", "vim.png", "atom.png"]
        }
      ],
    };
  }
};
</script>

<style lang="scss" scoped>
  .category-row {
    clear: both;
    text-align: center;
    + .category-row {
      margin-top: 62px;
    }
  }
  .skill--category_title {
    h3 {
      font-size: 24px;
      font-weight: 400;
      color: #333;
      text-transform: uppercase;
      font-family: 'Abel', sans-serif;
      text-align: center;
    }
  }
  .box-skill {
    box-sizing: content-box;
    padding: 24px;
    width: auto;
    height: 100px;
    display: inline-block;
    position: relative;
    text-align: center;
    vertical-align: middle;
  }
  .skill-logo {
    width: auto;
    height: 70px;
    display: inline-block;
    margin: 10px;
    position: relative;
    text-align: center;
    vertical-align: middle;
    img {
      position: relative;
      max-height: 100%;
      max-width: 100%;
      width: auto;
      height: auto;
      min-height: 54px;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
  @media screen and (max-width: $max-width-tablet) {
    .box-skill {
      padding: 18px;
    }
    .skill-logo {
      height: 65px;
    }
  }

  @media screen and (max-width: $max-width-mobile) {
    .box-skill {
      padding: 12px;
    }
    .skill-logo {
      height: 60px;
    }
    .category-row {
      + .category-row {
        margin-top: 42px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/skills/Skills.vue